import React, { Component } from "react";
import { SecondaryFormNav } from "../../components/SecondaryFormNav";
import { CertCheckbox } from "../../components/CertCheckbox";

class AddMinor extends Component {
  state = {
    heading: "Add a Minor to Your Application?",
    showProgressBar: true,
    pageId: "add-minor"
  };
  componentWillMount() {
    const stepData = this.props.stepData;
    if (!stepData.access) {
      this.props.previousStep(stepData);
    }
    this.props.setHeaderDisplay(
      this.state.heading,
      stepData.displayStep,
      this.state.showProgressBar,
      this.state.pageId,
      stepData.step
    );
    this.props.fields.minorCertification.value = false;
  }
  componentDidMount() {
    document.getElementById("root").scrollIntoView();
    window.scrollBy(0, -10);
  }
  handleNoMinor = () => {
    const stepData = this.props.stepData;
    stepData.altForward = true;
    this.props.nextStep(stepData);
  };
  handleAddMinor = fields => {
    const stepData = this.props.stepData;
    const isErr = this.props.validateStep(fields);
    stepData.altForward = false;
    if (!isErr) {
      this.props.addMinor();
      this.props.nextStep(stepData);
    } else {
      this.scrollToError();
    }
  };
  scrollToError = () => {
    const fields = this.props.fields;
    let errFields = [];
    Object.keys(fields).map(fieldName => {
      if (fields[fieldName].className === "input-err") {
        errFields.push(fieldName);
      }
      return fieldName;
    });
    const firstErr = document.querySelectorAll(`[name="${errFields[0]}"]`)[0];
    firstErr.scrollIntoView();
  };
  render() {
    const fields = this.props.fields;
    return (
      <div className="col-19">
        <p className="list-follows">
          If you would like to add a minor to your visitation application, you
          must be:
        </p>
        <ul className="unstyled-list single-line">
          <li>A parent or legal guardian of the minor OR</li>
          <li>
            An individual with notarized written approval from the minor’s
            parent or legal guardian.
          </li>
        </ul>
        <p className="list-follows">
          If the above is true, then you must be able to verify:
        </p>
        <ul className="unstyled-list single-line">
          <li>You meet the above criteria AND</li>
          <li>
            The minor is not a victim of the crime of the inmate they want to
            visit
          </li>
        </ul>
        <div className="minor-cert">
          <CertCheckbox
            name="minorCertification"
            value={fields.minorCertification.value}
            label={fields.minorCertification.label}
            required="true"
            onChange={this.props.handleInputChange}
            errMessage={fields.minorCertification.errMessage}
          />
        </div>
        <SecondaryFormNav
          primaryLabel="Add a Minor"
          primaryOptions={Object.keys(fields)}
          handlePrimaryClick={this.handleAddMinor}
          secondaryLabel="Do not add a minor"
          handleSecondaryClick={this.handleNoMinor}
        />
      </div>
    );
  }
}

export default AddMinor;



// WEBPACK FOOTER //
// ./src/pages/AddMinor/AddMinor.js